import { useEffect, useState } from "react";
import { t } from "i18next";
import humanizeDuration from "humanize-duration";
import { FaPersonWalking, FaCar } from "react-icons/fa6";

import useMapStore from "@/store/mapStore";
import { cn } from "@/lib/utils";

function PoiDetailsDistance({ className }: { className?: string }) {
  const routeDetails = useMapStore((state) => state.routeDetails);
  const currentLanguage = useMapStore((state) => state.currentLang);
  const mobileMode = useMapStore((state) => state.mobileMode);
  const navMode = useMapStore((state) => state.navMode);
  const [distanceInMeters, setDistanceInMeters] = useState(0);
  const [distanceInMinutes, setDistanceInMinutes] = useState("");

  useEffect(() => {
    setDistanceInMeters(Math.round(routeDetails?.details?.distance));

    const duration =
      navMode === "mall"
        ? routeDetails?.details?.duration?.realistic
        : routeDetails?.details?.duration?.realistic
          ? routeDetails?.details?.duration?.realistic
          : routeDetails?.details?.duration;
    let humanizedDuration = humanizeDuration(
      duration <= 60 ? 60 * 1000 : duration * 1000,
      {
        delimiter: ` ${t("and")} `,
        units: ["m"],
        largest: 1,
        round: true,
        language: currentLanguage === "zh" ? "zh_TW" : currentLanguage,
        fallbacks: ["en"],
      },
    );
    if (mobileMode) {
      humanizedDuration = humanizedDuration.replace(" minute", "min");
    }

    setDistanceInMinutes(humanizedDuration);
  }, [
    routeDetails?.details?.distance,
    currentLanguage,
    routeDetails?.details?.duration,
    mobileMode,
    navMode,
  ]);

  return (
    <div
      className={cn("flex items-center gap-2 text-sm lg:text-base", className)}
    >
      {navMode === "mall" ? (
        <FaPersonWalking className="text-lg text-primary" />
      ) : (
        <FaCar className="text-lg text-primary" />
      )}
      <span>
        {t("distance")}{" "}
        <strong>
          {distanceInMeters > 1000
            ? `${(distanceInMeters / 1000).toFixed(1)} ${t("kilometer-short")}`
            : `${distanceInMeters} ${t("meter-short")}`}
          / {distanceInMinutes}
        </strong>
      </span>
    </div>
  );
}

export default PoiDetailsDistance;
